import { render, staticRenderFns } from "./sectionInfo.vue?vue&type=template&id=9f8cc968&"
import script from "./sectionInfo.vue?vue&type=script&lang=js&"
export * from "./sectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports